import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
	selfSignupRequest: ["selfSignupId"],
	resendSelfSignupRequest: ["id"],
	resendBulkSelfSignupRequest: ["invitations"],
	selfSignupAllRequest: ["businessId", "options"],
	selfSignupUpdateRequest: ["selfSignup"],
	invitationSearchRequest: ["businessId", "filter", "options"],
	selfSignupCountRequest: ["businessId"],
	searchCountRequest: ["businessId", "filter"],
	selfSignupFilterRequest: ["businessId", "filter", "options"],
	selfSignupDeleteRequest: ["selfSignupId"],
	invitationUptakeRequest: ["businessId", "planId", "query", "options"],
	downloadUptakePdfRequest: ["businessId", "planId", "segmentId", "tags"],
	downloadUptakeCsvRequest: ["businessId", "planId", "segmentId", "tags"],

	selfSignupSuccess: ["selfSignup"],
	resendSelfSignupSuccess: ["signUpResend"],
	resendBulkSelfSignupSuccess: ["bulkSignUpResend"],
	selfSignupAllSuccess: ["selfSignups"],
	selfSignupUpdateSuccess: ["selfSignup"],
	invitationSearchSuccess: ["invitations"],
	selfSignupCountSuccess: ["count"],
	searchCountSuccess: ["searchCount"],
	selfSignupFilterSuccess: ["filter"],
	selfSignupDeleteSuccess: [],
	invitationUptakeSuccess: ["invitationUptake"],
	downloadUptakePdfSuccess: ["pdf"],
	downloadUptakeCsvSuccess: ["csv"],

	selfSignupFailure: ["error"],
	resendSelfSignupFailure: ["error"],
	resendBulkSelfSignupFailure: ["error"],
	selfSignupAllFailure: ["error"],
	selfSignupUpdateFailure: ["error"],
	invitationSearchFailure: ["error"],
	selfSignupCountFailure: ["error"],
	searchCountFailure: ["error"],
	selfSignupFilterFailure: ["error"],
	selfSignupDeleteFailure: ["error"],
	invitationUptakeFailure: ["error"],
	downloadUptakePdfFailure: ["error"],
	downloadUptakeCsvFailure: ["error"]
});

export const SelfSignupTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
	fetchingOne: null,
	resending: false,
	resendingAll: false,
	fetchingAll: false,
	fetchingCount: false,
	fetchingSearchCount: false,
	fetchingFilter: null,
	updating: null,
	deleting: false,
	fetchingInvitation: false,
	fetchingAllInvitations: false,
	fetchingInvitationUptake: false,
	downloadingUptakePdf: false,
	downloadingUptakeCsv: false,

	count: null,
	searchCount: null,
	filter: null,
	// deleting: null,
	selfSignup: null,
	signUpResend: null,
	bulkSignUpResend: null,
	invitations: null,
	selfSignups: null,
	allInvitations: null,
	invitationUptake: null,
	uptakePdf: null,
	uptakeCsv: null,

	errorOne: null,
	errorResend: null,
	errorResendBulk: null,
	errorAll: null,
	errorUpdating: null,
	errorInvitation: null,
	errorCount: null,
	errorSearchCount: null,
	errorFilter: null,
	errorDeleting: null,
	errorAllInvitations: null,
	errorInvitationUptake: null,
	errorDownloadUptakePdf: null,
	errorDownloadUptakeCsv: null
});

/* ------------- Reducers ------------- */

// request the data from an api
export const request = (state) => {
	return { ...state, fetchingOne: true, selfSignup: null };
};

// request the data from an api
export const resendRequest = (state) => {
	return { ...state, resending: true, signUpResend: null };
};

// request the data from an api
export const bulkResendRequest = (state) => {
	return { ...state, resendingAll: true, bulkSignUpResend: null };
};

// request the data from an api
export const allRequest = (state) => {
	return { ...state, fetchingAll: true, selfSignups: null };
};
export const allInvitationRequest = (state) => {
	return { ...state, fetchingAllInvitations: true, allInvitations: null };
};
// request to update from an api
export const updateRequest = (state) => {
	return { ...state, updating: true };
};

export const invitationRequest = (state) => {
	return {
		fetchingInvitation: true,
		invitations: null,
	};
};

//request to get count from api
export const countRequest = (state) => {
	return { ...state, fetchingCount: true, count: null }
}
//request to get count from api
export const searchCountRequest = (state) => {
	return { ...state, fetchingSearchCount: true, searchCount: null }
}

//request to get filter from api
export const filterRequest = (state) => {
	return { ...state, fetchingFilter: true, filter: null }
}

// request to delete from an api
export const deleteRequest = (state) => {
	return { ...state, deleting: true, errorDeleting: null };
};

//business invitation uptake request
export const invitationUptakeRequest = (state) => {
	return { ...state, fetchingInvitationUptake: true, invitationUptake: null }
}

export const downloadUptakePdfRequest = (state) => {
	return {
		...state, downloadingUptakePdf: true, uptakePdf: null, errorDownloadUptakePdf: null
	}
}

export const downloadUptakeCsvRequest = (state) => {
	return {
		...state, downloadingUptakeCsv: true, uptakeCsv: null, errorDownloadUptakeCsv: null
	}
}

// successful api lookup for single entity
export const success = (state, action) => {
	const { selfSignup } = action;
	return { ...state, fetchingOne: false, errorOne: null, selfSignup };
};

// successful api lookup for single entity
export const resendSuccess = (state, action) => {
	const { signUpResend } = action;
	return { ...state, resending: false, errorResend: null, signUpResend };
};
export const bulkResendSuccess = (state, action) => {
	const { bulkSignUpResend } = action;
	return { ...state, resendingAll: false, errorResendBulk: null, bulkSignUpResend };
};


// successful api lookup for all entities
export const allSuccess = (state, action) => {
	const { selfSignups } = action;
	return { ...state, fetchingAll: false, errorAll: null, selfSignups };
};
export const allInvitationsSuccess = (state, action) => {
	const { selfSignups } = action;
	return { ...state, fetchingAllInvitations: false, errorAllInvitations: null, allInvitations: selfSignups };
};
// successful api update
export const updateSuccess = (state, action) => {
	const { selfSignup } = action;
	return { ...state, updating: false, errorUpdating: null, selfSignup };
};

export const invitationSuccess = (state, action) => {
	const { invitations } = action;
	return {
		...state,
		fetchingInvitation: false,
		errorInvitation: null,
		invitations,
	};
};

export const downloadUptakePdfSuccess = (state, action) => {
	const { pdf } = action;
	return {
		...state, downloadingUptakePdf: false, uptakePdf: pdf, errorDownloadUptakePdf: null
	}
};

export const downloadUptakeCsvSuccess = (state, action) => {
	const { csv } = action;
	return {
		...state, downloadingUptakeCsv: false, uptakeCsv: csv, errorDownloadUptakeCsv: null
	}
};

// successful api count
export const countSuccess = (state, action) => {
	const { count } = action;
	return { ...state, fetchingCount: false, errorCount: null, count }
}
export const searchCountSuccess = (state, action) => {
	const { searchCount } = action;
	return { ...state, fetchingSearchCount: false, errorSearchCount: null, searchCount }
}

// successful api filter
export const filterSuccess = (state, action) => {
	const { filter } = action;
	return { ...state, fetchingFilter: false, errorFilter: null, filter }
}

// successful api delete
export const deleteSuccess = (state) => {
	return { ...state, deleting: false, errorDeleting: null, selfSignup: null };
};

//successful invitation uptake call
export const invitationUptakeSuccess = (state, action) => {
	const { invitationUptake } = action;
	return { ...state, fetchingInvitationUptake: false, errorInvitationUptake: null, invitationUptake }
}

// Something went wrong fetching a single entity.
export const failure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingOne: false, errorOne: error, selfSignup: null };
};

// Something went wrong fetching a single entity.
export const resendFailure = (state, action) => {
	const { error } = action;
	return { ...state, resending: false, errorResend: error, signUpResend: null };
};

// Something went wrong fetching a single entity.
export const bulkResendFailure = (state, action) => {
	const { error } = action;
	return { ...state, resendingAll: false, errorResendBulk: error, bulkSignUpResend: null };
};
// Something went wrong fetching all entities.
export const allFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingAll: false, errorAll: error, selfSignups: null };
};
export const allInvitationsFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingAllInvitations: false, errorAllInvitations: error, allInvitations: null };
};
// Something went wrong updating.
export const updateFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		updating: false,
		errorUpdating: error,
		selfSignup: state.selfSignup,
	};
};

export const invitationFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		fetchingInvitation: false,
		errorInvitation: error,
		invitations: null,
	};
};

export const downloadUptakePdfFailure = (state, action) => {
	const { error } = action;
	return {
		...state, downloadingUptakePdf: false, uptakePdf: null, errorDownloadUptakePdf: error
	}
};

export const downloadUptakeCsvFailure = (state, action) => {
	const { error } = action;
	return {
		...state, downloadingUptakeCsv: false, uptakeCsv: null, errorDownloadUptakeCsv: error
	}
};


// Something went wrong counting
export const countFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingCount: false, errorCount: error, count: null }
}
export const searchCountFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingSearchCount: false, errorSearchCount: error, searchCount: null }
}

// Something went wrong filtering
export const filterFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingFilter: false, errorFilter: error, filter: null }
}


// Something went wrong deleting.
export const deleteFailure = (state, action) => {
	const { error } = action;
	return {
		...state,
		deleting: false,
		errorDeleting: error,
		selfSignup: state.selfSignup,
	};
};

//something went wrong fetching invitation uptake request
export const invitationUptakeFailure = (state, action) => {
	const { error } = action;
	return { ...state, fetchingInvitationUptake: false, errorInvitationUptake: error, invitationUptake: null }
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
	[Types.SELF_SIGNUP_REQUEST]: request,
	[Types.RESEND_SELF_SIGNUP_REQUEST]: resendRequest,
	[Types.RESEND_BULK_SELF_SIGNUP_REQUEST]: bulkResendRequest,
	[Types.SELF_SIGNUP_ALL_REQUEST]: allRequest,
	[Types.SELF_SIGNUP_ALL_REQUEST]: allInvitationRequest,
	[Types.SELF_SIGNUP_UPDATE_REQUEST]: updateRequest,
	[Types.INVITATION_SEARCH_REQUEST]: invitationRequest,
	[Types.SELF_SIGNUP_COUNT_REQUEST]: countRequest,
	[Types.SEARCH_COUNT_REQUEST]: searchCountRequest,
	[Types.SELF_SIGNUP_FILTER_REQUEST]: filterRequest,
	[Types.SELF_SIGNUP_DELETE_REQUEST]: deleteRequest,
	[Types.INVITATION_UPTAKE_REQUEST]: invitationUptakeRequest,
	[Types.DOWNLOAD_UPTAKE_PDF_REQUEST]: downloadUptakePdfRequest,
	[Types.DOWNLOAD_UPTAKE_CSV_REQUEST]: downloadUptakeCsvRequest,

	[Types.SELF_SIGNUP_SUCCESS]: success,
	[Types.RESEND_SELF_SIGNUP_SUCCESS]: resendSuccess,
	[Types.RESEND_BULK_SELF_SIGNUP_SUCCESS]: bulkResendSuccess,
	[Types.SELF_SIGNUP_ALL_SUCCESS]: allSuccess,
	[Types.SELF_SIGNUP_ALL_SUCCESS]: allInvitationsSuccess,
	[Types.SELF_SIGNUP_UPDATE_SUCCESS]: updateSuccess,
	[Types.INVITATION_SEARCH_SUCCESS]: invitationSuccess,
	[Types.SELF_SIGNUP_COUNT_SUCCESS]: countSuccess,
	[Types.SEARCH_COUNT_SUCCESS]: searchCountSuccess,
	[Types.SELF_SIGNUP_FILTER_SUCCESS]: filterSuccess,
	[Types.SELF_SIGNUP_DELETE_SUCCESS]: deleteSuccess,
	[Types.INVITATION_UPTAKE_SUCCESS]: invitationUptakeSuccess,
	[Types.DOWNLOAD_UPTAKE_PDF_SUCCESS]: downloadUptakePdfSuccess,
	[Types.DOWNLOAD_UPTAKE_CSV_SUCCESS]: downloadUptakeCsvSuccess,

	[Types.SELF_SIGNUP_FAILURE]: failure,
	[Types.RESEND_SELF_SIGNUP_FAILURE]: resendFailure,
	[Types.RESEND_BULK_SELF_SIGNUP_FAILURE]: bulkResendFailure,
	[Types.SELF_SIGNUP_ALL_FAILURE]: allFailure,
	[Types.SELF_SIGNUP_ALL_FAILURE]: allInvitationsFailure,
	[Types.SELF_SIGNUP_UPDATE_FAILURE]: updateFailure,
	[Types.INVITATION_SEARCH_FAILURE]: invitationFailure,
	[Types.SELF_SIGNUP_COUNT_FAILURE]: countFailure,
	[Types.SEARCH_COUNT_FAILURE]: searchCountFailure,
	[Types.SELF_SIGNUP_FILTER_FAILURE]: filterFailure,
	[Types.SELF_SIGNUP_DELETE_FAILURE]: deleteFailure,
	[Types.INVITATION_UPTAKE_FAILURE]: invitationUptakeFailure,
	[Types.DOWNLOAD_UPTAKE_PDF_FAILURE]: downloadUptakePdfFailure,
	[Types.DOWNLOAD_UPTAKE_CSV_FAILURE]: downloadUptakeCsvFailure,
});